@import 'styles/mixins';
@import 'styles/variables';

.title {
  @include xl-semibold;
  color: var(--neutral-90);
  margin-bottom: 24px;
}
